module.exports = __webpack_public_path__ + "img/Avatar-1.2782f27b.png";